import { PROXIMITY_EXIT_RADIUS, SPATIAL_AUDIO_MIN_GAIN } from './constants.js';
const FULL_VOLUME_RADIUS = 1;
/**
 * Lautstaerkekurve fuer Spatial Audio: volle Lautstaerke bis 1 Tile,
 * danach linearer Abfall bis zum EXIT-Radius, dort Minimal-Gain.
 * Pure Funktion — wird im Client pro Frame aufgerufen und ist hier testbar.
 */
export function gainForDistance(distanceTiles) {
    if (distanceTiles <= FULL_VOLUME_RADIUS)
        return 1;
    if (distanceTiles >= PROXIMITY_EXIT_RADIUS)
        return SPATIAL_AUDIO_MIN_GAIN;
    const t = (distanceTiles - FULL_VOLUME_RADIUS) / (PROXIMITY_EXIT_RADIUS - FULL_VOLUME_RADIUS);
    return 1 - t * (1 - SPATIAL_AUDIO_MIN_GAIN);
}
//# sourceMappingURL=audio.js.map